<div class="bg-black min-h-[280px] flex p-4 gap-4 flex-wrap custom-bg-banner">
        <img src="assets/images/home/logo-wecommerce.png" class="w-[140px] mb-4"/>
        <div class="flex flex-col gap-10">
            <span class="custom-text-banner">{{ 'benefits_kb.loyalty_2026.configure_and_order_products_directly' | translate }}</span>
                    <app-button [secondary]="true" size="l" class="w-full" (click)="goToKbBath()">
                        <span class="pt-4">{{ 'benefits_kb.loyalty_2026.access_product_catalog' | translate }}</span>
                    </app-button>
        </div>
</div>
